module.exports = __webpack_public_path__ + "files/b37abaa1ef187838dc0bd2a49de9f5d8.png";